// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__MK0b0","mobile-menu":"Navbar_mobile-menu__gqynN","mobile-nav":"Navbar_mobile-nav__5FyiN"};